import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';

import ContextPagination from 'rebook/apps/base/components/ContextPagination';
import SearchResultEmpty from 'rebook/apps/search/components/SearchResultEmpty';
import BookList from 'rebook/apps/books/components/BookList';
import BackLink from 'rebook/apps/base/components/BackLink';
import pluralize from 'rebook/apps/utils/text/pluralize';
import * as SearchAudioBooksActions from 'rebook/apps/search/actions/SearchAudioBooksActions';

import styles from './style.scss';


class SearchAudioBooksView extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.SearchAudioBooksActions.fetchInitialData(this.props.location);
  }

  componentWillUnmount() {
    this.props.SearchAudioBooksActions.resetData();
  }

  changePage(pageNumber) {
    this.props.SearchAudioBooksActions.fetchAudioBook(pageNumber);
  }

  render() {
    const {
      audioBookList, audioBooksCount, query,
      pageNumber, lastPageNumber, isLoading,
    } = this.props.searchAudioBooks;

    return (
      <div className="section">
        {isLoading && <BookList books={[...Array(5)]} />}
        {!isLoading && get(audioBookList, 'length', 0) > 0 && (
          <React.Fragment>
            <BackLink link={`/search/?q=${query}`} extraClassName={styles.breadCrumbs} isMargined>
              <span className="link">Все результаты</span>
            </BackLink>
            <div className="title-1">
              Все аудиокниги по запросу «{query}»
            </div>
            <small>
              {audioBooksCount} {pluralize(audioBooksCount, 'аудиокнига', 'аудиокниги', 'аудиокниг')}
            </small>
            <BookList books={audioBookList} />
            <ContextPagination
              onPageChange={(newPageNumber) => this.changePage(newPageNumber)}
              currentPage={pageNumber}
              lastPage={lastPageNumber} />
          </React.Fragment>
        )}
        {!isLoading && get(audioBookList, 'length', 0) === 0 && (
          <SearchResultEmpty />
        )}
      </div>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    searchAudioBooks: state.searchAudioBooks,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    SearchAudioBooksActions: bindActionCreators(SearchAudioBooksActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchAudioBooksView);
